import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'optimizeresult-dialog',
  templateUrl: './optimizeresult-dialog.component.html',
  styleUrls: ['./optimizeresult-dialog.component.scss']
})
export class OptimizeresultDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OptimizeresultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  


   }

  ngOnInit() {

 
  }

}
